import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Card, Col, CardBody, CardTitle, Label, Button, Form, Input, Row, Badge, Alert } from "reactstrap";
import * as actions from '../../store/actions';
import { toast } from "react-toastify";

const CommissionSettings = ({ commission }) => {
  if(!commission) {
    return null;
  }
  
  const dispatch = useDispatch();
  const [providerRate, setProviderRate] = useState("");
  const [appRate, setAppRate] = useState("");
  const [tamaraRate, setTamaraRate] = useState("");

  const handleProviderSubmit = (e) => {
    e.preventDefault();

    if (!isNaN(providerRate) && providerRate !== "") {
      const commissionRate = parseFloat(providerRate);
      if (commissionRate >= 0 && commissionRate <= 100) {
        dispatch(actions.updateCommissionRate({ newRate: commissionRate, id: commission.id }));
        setProviderRate("");
        toast.success("تم تحديث عمولة مقدم الخدمة بنجاح", {
          icon: "✅",
          position: "top-center"
        });
      } else {
        toast.error("معدل العمولة يجب أن يكون بين 0 و 100.");
      }
    } else {
      toast.error("معدل العمولة غير صالح.");
    }
  };

  const handleAppSubmit = (e) => {
    e.preventDefault();

    if (!isNaN(appRate) && appRate !== "") {
      const commissionRate = parseFloat(appRate);
      if (commissionRate >= 0 && commissionRate <= 100) {
        dispatch(actions.updateAppCommissionRate({ newRate: commissionRate, id: commission.id }));
        setAppRate("");
        toast.success("تم تحديث عمولة التطبيق بنجاح", {
          icon: "✅",
          position: "top-center"
        });
      } else {
        toast.error("معدل العمولة يجب أن يكون بين 0 و 100.");
      }
    } else {
      toast.error("معدل العمولة غير صالح.");
    }
  };

  const handleTamaraSubmit = (e) => {
    e.preventDefault();

    if (!isNaN(tamaraRate) && tamaraRate !== "") {
      const commissionRate = parseFloat(tamaraRate);
      if (commissionRate >= 0 && commissionRate <= 100) {
        dispatch(actions.updateTamaraCommissionRate({ newRate: commissionRate, id: commission.id }));
        setTamaraRate("");
        toast.success("تم تحديث عمولة تمارا بنجاح", {
          icon: "✅",
          position: "top-center"
        });
      } else {
        toast.error("معدل العمولة يجب أن يكون بين 0 و 100.");
      }
    } else {
      toast.error("معدل العمولة غير صالح.");
    }
  };

  return (
    <Col xl={12} className="mb-4">
      <div className="d-flex align-items-center mb-3">
        <div className="avatar-sm me-3">
          <span className="avatar-title rounded-circle bg-primary-subtle text-primary font-size-20">
            <i className="bx bx-percentage"></i>
          </span>
        </div>
        <div>
          <h5 className="mb-1">إعدادات معدلات العمولة</h5>
          <p className="text-muted mb-0">إدارة نسب العمولة لمقدمي الخدمات والتطبيق</p>
        </div>
      </div>
      
      <Row className="g-3">
        {/* Provider Commission Card */}
        {/* <Col lg={6}>
          <Card className="border shadow-sm h-100" style={{ borderRadius: '12px', overflow: 'hidden' }}>
            <div className="bg-primary bg-gradient p-3">
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0">
                  <i className="bx bx-store font-size-24 text-white"></i>
                </div>
                <div className="flex-grow-1 ms-3">
                  <h5 className="text-white mb-0">عمولة مقدم الخدمة</h5>
                  <p className="text-white-50 mb-0" style={{ fontSize: '0.875rem' }}>
                    النسبة المحصلة من مقدمي الخدمات
                  </p>
                </div>
              </div>
            </div>
            
            <CardBody className="p-4">
              <div className="mb-4">
                <div className="d-flex align-items-center justify-content-between p-3 rounded" 
                     style={{ backgroundColor: '#f8f9fa' }}>
                  <div className="d-flex align-items-center">
                    <i className="bx bx-info-circle text-primary me-2 font-size-20"></i>
                    <span className="text-muted">المعدل الحالي</span>
                  </div>
                  <Badge color="primary" className="font-size-16 px-3 py-2">
                    {commission.commission_rates}%
                  </Badge>
                </div>
              </div>
              
              <Form onSubmit={handleProviderSubmit}>
                <div className="mb-3">
                  <Label for="providerRate" className="fw-semibold">
                    <i className="bx bx-edit-alt me-2"></i>
                    معدل جديد (%)
                  </Label>
                  <div className="input-group">
                    <Input
                      type="number"
                      id="providerRate"
                      placeholder="أدخل النسبة"
                      value={providerRate}
                      onChange={(e) => setProviderRate(e.target.value)}
                      min="0"
                      max="100"
                      step="0.1"
                      className="form-control-lg"
                      style={{ borderRadius: '8px 0 0 8px' }}
                    />
                    <span className="input-group-text bg-primary-subtle text-primary fw-bold" 
                          style={{ borderRadius: '0 8px 8px 0' }}>
                      %
                    </span>
                  </div>
                  <small className="text-muted">القيمة المسموحة: 0 - 100</small>
                </div>
                <Button 
                  type="submit" 
                  color="primary" 
                  block 
                  size="lg"
                  className="mt-3"
                  style={{ borderRadius: '8px' }}
                >
                  <i className="bx bx-save me-2"></i>
                  حفظ التعديل
                </Button>
              </Form>
            </CardBody>
          </Card>
        </Col> */}

        {/* App Commission Card */}
        <Col lg={6}>
          <Card className="border shadow-sm h-100" style={{ borderRadius: '12px', overflow: 'hidden' }}>
            <div className="bg-success bg-gradient p-3">
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0">
                  <i className="bx bx-mobile font-size-24 text-white"></i>
                </div>
                <div className="flex-grow-1 ms-3">
                  <h5 className="text-white mb-0">عمولة التطبيق</h5>
                  <p className="text-white-50 mb-0" style={{ fontSize: '0.875rem' }}>
                    النسبة المحصلة من المستخدمين
                  </p>
                </div>
              </div>
            </div>
            
            <CardBody className="p-4">
              <div className="mb-4">
                <div className="d-flex align-items-center justify-content-between p-3 rounded" 
                     style={{ backgroundColor: '#f8f9fa' }}>
                  <div className="d-flex align-items-center">
                    <i className="bx bx-info-circle text-success me-2 font-size-20"></i>
                    <span className="text-muted">المعدل الحالي</span>
                  </div>
                  <Badge color="success" className="font-size-16 px-3 py-2">
                    {commission.app_commission_rates || 0}%
                  </Badge>
                </div>
              </div>
              
              <Form onSubmit={handleAppSubmit}>
                <div className="mb-3">
                  <Label for="appRate" className="fw-semibold">
                    <i className="bx bx-edit-alt me-2"></i>
                    معدل جديد (%)
                  </Label>
                  <div className="input-group">
                    <Input
                      type="number"
                      id="appRate"
                      placeholder="أدخل النسبة"
                      value={appRate}
                      onChange={(e) => setAppRate(e.target.value)}
                      min="0"
                      max="100"
                      step="0.1"
                      className="form-control-lg"
                      style={{ borderRadius: '8px 0 0 8px' }}
                    />
                    <span className="input-group-text bg-success-subtle text-success fw-bold" 
                          style={{ borderRadius: '0 8px 8px 0' }}>
                      %
                    </span>
                  </div>
                  <small className="text-muted">القيمة المسموحة: 0 - 100</small>
                </div>
                <Button 
                  type="submit" 
                  color="success" 
                  block 
                  size="lg"
                  className="mt-3"
                  style={{ borderRadius: '8px' }}
                >
                  <i className="bx bx-save me-2"></i>
                  حفظ التعديل
                </Button>
              </Form>
            </CardBody>
          </Card>
        </Col>

        {/* Tamara Commission Card */}
        <Col lg={6}>
          <Card className="border shadow-sm h-100" style={{ borderRadius: '12px', overflow: 'hidden' }}>
            <div className="bg-warning bg-gradient p-3">
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0">
                  <i className="bx bx-credit-card font-size-24 text-white"></i>
                </div>
                <div className="flex-grow-1 ms-3">
                  <h5 className="text-white mb-0">عمولة تمارا</h5>
                  <p className="text-white-50 mb-0" style={{ fontSize: '0.875rem' }}>
                    النسبة المحصلة على مدفوعات تمارا
                  </p>
                </div>
              </div>
            </div>

            <CardBody className="p-4">
              <div className="mb-4">
                <div className="d-flex align-items-center justify-content-between p-3 rounded"
                     style={{ backgroundColor: '#f8f9fa' }}>
                  <div className="d-flex align-items-center">
                    <i className="bx bx-info-circle text-warning me-2 font-size-20"></i>
                    <span className="text-muted">المعدل الحالي</span>
                  </div>
                  <Badge color="warning" className="font-size-16 px-3 py-2 text-dark">
                    {commission.tamara_commission || 0}%
                  </Badge>
                </div>
              </div>

              <Form onSubmit={handleTamaraSubmit}>
                <div className="mb-3">
                  <Label for="tamaraRate" className="fw-semibold">
                    <i className="bx bx-edit-alt me-2"></i>
                    معدل جديد (%)
                  </Label>
                  <div className="input-group">
                    <Input
                      type="number"
                      id="tamaraRate"
                      placeholder="أدخل النسبة"
                      value={tamaraRate}
                      onChange={(e) => setTamaraRate(e.target.value)}
                      min="0"
                      max="100"
                      step="0.1"
                      className="form-control-lg"
                      style={{ borderRadius: '8px 0 0 8px' }}
                    />
                    <span className="input-group-text bg-warning-subtle text-warning fw-bold"
                          style={{ borderRadius: '0 8px 8px 0' }}>
                      %
                    </span>
                  </div>
                  <small className="text-muted">القيمة المسموحة: 0 - 100</small>
                </div>
                <Button
                  type="submit"
                  color="warning"
                  block
                  size="lg"
                  className="mt-3"
                  style={{ borderRadius: '8px' }}
                >
                  <i className="bx bx-save me-2"></i>
                  حفظ التعديل
                </Button>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Alert color="info" className="mt-3 border-0 shadow-sm" style={{ borderRadius: '8px' }}>
        <i className="bx bx-info-circle me-2"></i>
        <strong>ملاحظة:</strong> سيتم تطبيق معدلات العمولة الجديدة على جميع المعاملات المستقبلية فقط.
      </Alert>
    </Col>
  );
};

export default CommissionSettings;
